import React, { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { HiShieldCheck, HiXCircle, HiRefresh } from 'react-icons/hi'
import { acceptItem } from '../services/InventoryService'
import { el } from 'date-fns/locale'

export default function AcceptItem() {
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()

    const [status, setStatus] = useState('processing')
    const [message, setMessage] = useState('')

    useEffect(() => {
        const token = searchParams.get('token')

        if (!token) {
            setStatus('error')
            setMessage('Invalid or missing security token.')
            return
        }
        console.log('Received token:', token) // Debug log to verify token retrieval
        processAccept(token)
    }, [])

    const processAccept = async (token) => {
        try {
            const response = await acceptItem({ token: token })

            setStatus('success')
            setMessage(response.message || 'Request successfully processed.')

            if (response.error) {
                setStatus('error')
                setMessage(response.error || 'Unable to process your request. Please try again later.')
            } else if (response.success) {
                setStatus('success')
                setMessage(response.message || 'Request successfully processed.')
            }
        } catch (error) {
            setStatus('error')
            setMessage(error.message || 'Unable to process your request. Please try again later.')
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-200 p-6">
            <div className="w-full max-w-lg bg-white shadow-xl rounded-2xl p-10 text-center border border-gray-100">
                {status === 'processing' && (
                    <div className="space-y-6">
                        <div className="flex justify-center">
                            <div className="bg-blue-100 p-5 rounded-full animate-pulse">
                                <HiRefresh className="w-12 h-12 text-blue-600 animate-spin" />
                            </div>
                        </div>

                        <h2 className="text-2xl font-bold text-gray-800">Processing Your Request</h2>

                        <p className="text-gray-500 leading-relaxed">
                            Please wait while we verify and process your email action request. This may take a few
                            seconds.
                        </p>
                    </div>
                )}

                {/* Success State */}
                {status === 'success' && (
                    <div className="space-y-6">
                        <div className="flex justify-center">
                            <div className="bg-green-100 p-5 rounded-full">
                                <HiShieldCheck className="w-12 h-12 text-green-600" />
                            </div>
                        </div>

                        <h2 className="text-2xl font-bold text-green-600">Request Completed</h2>

                        <p className="text-gray-600 leading-relaxed">{message}</p>

                        <button
                            onClick={() => navigate('/login')}
                            className="mt-6 w-full bg-blue-600 hover:bg-blue-700 transition text-white py-3 rounded-xl font-semibold shadow-md"
                        >
                            Go to Portal Login
                        </button>
                    </div>
                )}

                {/* Error State */}
                {status === 'error' && (
                    <div className="space-y-6">
                        <div className="flex justify-center">
                            <div className="bg-red-100 p-5 rounded-full">
                                <HiXCircle className="w-12 h-12 text-red-600" />
                            </div>
                        </div>

                        <h2 className="text-2xl font-bold text-red-600">Action Failed</h2>

                        <p className="text-gray-600 leading-relaxed">{message}</p>

                        <button
                            onClick={() => navigate('/login')}
                            className="mt-6 w-full bg-blue-600 hover:bg-blue-700 transition text-white py-3 rounded-xl font-semibold shadow-md"
                        >
                            Return to Login
                        </button>
                    </div>
                )}
            </div>
        </div>
    )
}
